import store, { actions, history } from './store';

export { actions, history };
export default store;